// import common from '@/store/mutations';
import types from './mutation-types';

export default {
	// ...common,
	[types.SET]: (state, { key, value }) => {
		state[key] = value;
	},
	/*
	[types.SEARCH_PARAM]: (state, payload) => {
		state.searchParams[payload.key] = payload.value;
	},
	[types.TABLE_LIST]: (state, payload) => {
		state.tableInfoList = payload;
		if (state.tableInfoList != null) {
			state.tableInfoList.forEach(row => {});
		}

		console.log('tableInfoList 조회');
	},
	*/
	setTableInfoList: (state, payload) => {
		//console.log('setTableInfoList 조회', payload);
		state.tableInfoList = payload;
	},
	setSearchParam(state, { key, value }) {
		state.searchParams[key] = value;
	},
	setUserPopSearchParam(state, { key, value }) {
		state.searchUserPopParams[key] = value;
	},
	closeRegisterModal(state) {
		state.registerModal = { open: false, regId: 'sys', chgId: 'sys', plantCd: 'HV21' };
	},
	setNotification(state, { key, value }) {
		state.registerModal[key] = value;
	},
	setSelectedRow(state, payload) {
		state.registerModal = payload;
	}
};
